import { render, staticRenderFns } from "./MaterialMapping.vue?vue&type=template&id=0adfa1be&scoped=true"
import script from "./MaterialMapping.vue?vue&type=script&lang=js"
export * from "./MaterialMapping.vue?vue&type=script&lang=js"
import style0 from "./MaterialMapping.vue?vue&type=style&index=0&id=0adfa1be&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adfa1be",
  null
  
)

export default component.exports